import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import ViewerJs from 'viewerjs';
var propTypes = {
  ready: PropTypes.func,
  show: PropTypes.func,
  shown: PropTypes.func,
  hide: PropTypes.func,
  hidden: PropTypes.func,
  view: PropTypes.func,
  viewed: PropTypes.func,
  zoom: PropTypes.func,
  zoomed: PropTypes.func,
  asyncLoad: PropTypes.bool
};
var defaultProps = {
  ready: function ready() {},
  show: function show() {},
  shown: function shown() {},
  hide: function hide() {},
  hidden: function hidden() {},
  view: function view() {},
  viewed: function viewed() {},
  zoom: function zoom() {},
  zoomed: function zoomed() {},
  asyncLoad: false
};

var Viewer = /*#__PURE__*/function (_Component) {
  _inherits(Viewer, _Component);

  var _super = _createSuper(Viewer);

  function Viewer(props) {
    _classCallCheck(this, Viewer);

    return _super.call(this, props);
  }

  _createClass(Viewer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.asyncLoad) {
        this.viewerCase = new ViewerJs(ReactDOM.findDOMNode(this.views), _objectSpread({
          url: 'data-original'
        }, this.props));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.asyncLoad) {
        if (this.viewerCase) {
          this.viewerCase.update();
        } else {
          this.viewerCase = new ViewerJs(ReactDOM.findDOMNode(this.views), _objectSpread({
            url: 'data-original'
          }, this.props));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.viewerCase.destroy();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          _this.views = el;
        }
      }, this.props.children);
    }
  }]);

  return Viewer;
}(Component);

;
Viewer.propTypes = propTypes;
Viewer.defaultProps = defaultProps;
export default Viewer;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-image/src/Viewer.js